import { throwIfAborted } from '../abort.js';
/** One owner-scoped snapshot per visit; an explicit session refresh rechecks geography. */
export function fundingContextQuery(client) {
    return {
        queryKey: ['onramp', client.cacheKey, 'context'],
        queryFn: ({ signal }) => client.getContext(signal),
        staleTime: Infinity,
        gcTime: 60_000,
        retry: false,
        refetchOnWindowFocus: false,
        meta: { persist: false },
    };
}
export async function contextForSession(cache, client, signal, navigationKey = 0) {
    const previous = cache
        .getQueryCache()
        .findAll({ queryKey: ['onramp', client.cacheKey, 'session'] });
    const refresh = navigationKey !== 0 ||
        previous.some(({ state }) => Boolean(state.dataUpdatedAt || state.errorUpdatedAt));
    const context = await cache.fetchQuery({
        ...fundingContextQuery(client),
        ...(refresh ? { staleTime: 0 } : {}),
    });
    throwIfAborted(signal);
    return context;
}
